module.exports = __webpack_public_path__ + "static/ambient-6be956cc815b64dca50dc234f00e0702.mp3";